<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box text-center">
          <!-- /.box-header -->
          <div class="del-block m-t-5" v-if="up">
            <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">
              <i class="fa fa-trash"></i>
            </div>
          </div>
          <div class="box-body form" style="display: flex; flex-direction: column; align-items: center;">
            <br/>
            <div>
              <div class="col-xs-12 p-10" >
                <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
                  <div class="text-left">
                    <div class="col-xs-12 p-x-0 m-b-20 text-center" style="margin-bottom: 4em;">
                      <h3>複製此分店所有設定至其他店家</h3>
                    </div>

                    <!-- 參與店家 -->
                    <!-- <muti-select-two-v2 v-if="addStoresSetting.options.length > 0" :setting="addStoresSetting"></muti-select-two-v2> -->
                    <v-multiselect-listbox class="col-xs-12" :options="addStoresSetting.options"
                      :reduce-display-property="(option) => option.label"
                      :reduce-value-property="(option) => option.value"
                      search-options-placeholder="搜尋..."
                      selected-options-placeholder="搜尋..."
                      v-model="addStoresSetting.choose"
                    />
                    <div class="col-xs-12 text-right">
                      <p class="text-12">已選 {{this.addStoresSetting.choose.length}} 間</p>
                    </div>
                    <!-- <muti-select-two-v2 v-if="addStoresSetting_cr.options.length > 0" :setting="addStoresSetting_cr"> </muti-select-two-v2> -->
                    <!--{{addStoresSetting.choose}}-->
                  </div>
                </div>
              </div>
          </div>
          </div>
          <div class="box-footer text-center">
            <button @click="$router.go(-1)" class="btn btn-fail text-black">
              取消
            </button>
            <button class="btn btn-success" @click="checkSetting()" v-if="!up">
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Require needed datatables modules
import moment from 'moment'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import VueTimepicker from 'vue2-timepicker'

export default {
  components: {
    'date-time-picker': datetimePicker,
    VueTimepicker
  },
  data () {
    return {
      menuState: 4,
      name: '',
      description: '',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      addAmount: 5,
      settingId: '',
      type: 1, // 1 = 小圖， 2 = 大圖
      currentId: '',
      smImgSrc: '',
      up: false,
      enableOption: [
        {label: '啟用', value: 1},
        {label: '關閉', value: 0}
      ],
      delOption: {
        id: 'delModal',
        title: '刪除時段停賣設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delDisableSchedule'
          }
        ]
      },
      delItemOption: {
        id: 'delModal',
        title: '刪除商品設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delDisableScheduleItem'
          }
        ]
      },
      // time
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      dateoption_rule: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '248px',
          'min-width': '248px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px 12px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555',
          'width': '280px',
          'min-width': '280px',
          'text-align': 'left'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      limit_rule: [
        {
          type: 'fromto',
          from: moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      prodTypeOptions: [
        { label: '商品', value: 1 },
        { label: '套餐', value: 3 },
        { label: '配料', value: 2 },
        { label: '商品分類', value: 10 },
        { label: '品項選擇區', value: 11 },
        { label: '配料群組', value: 20 }
      ],
      srcIdTypeOptions: [
        { label: '廠商料號', value: 1 },
        { label: '平台商品ID', value: 2 }
      ],
      item_list: [],
      rule_list: [],
      ruleTypeOptions: [
        { label: '每日', value: 0 },
        { label: '指定日期', value: 1 },
        { label: '指定星期', value: 2 },
        { label: '每月幾號', value: 3 }
      ],
      offdaySetting: {
        options: {
          weekDay: [
            {label: '週日', value: 1},
            {label: '週一', value: 2},
            {label: '週二', value: 3},
            {label: '週三', value: 4},
            {label: '週四', value: 5},
            {label: '週五', value: 6},
            {label: '週六', value: 7}
          ]
        }
      },

      brandSelect: {
        value: 999999,
        label: '==品牌=='
      },
      storeSelect: {
        value: 999999,
        label: '所有門市'
      },
      // 影響菜單是否能讀取到店家
      brandBrief: [],
      storeBrief: [],
      addStoresSetting: {
        options: [],
        choose: []
      },
      // 停賣菜單
      menuId: null,
      brandId: null,
      category: [],
      product: [],
      prodNumList: {},
      menuInfo: {},
      menuList: '',
      // if created checkbox all true, if not all false
      created: false,
      getTimes: 0,
      time: 0,
      accessory: [],
      disTableList: [],
      adjustCheckbox: false,
      options: [],
      // 停賣菜單
      trigger_load_menu: true,
      loadmenu_id: null
    }
  },
  methods: {
    // 不需屏除已設定的店家
    getStoreLimitSetting (brandId) {
      var self = this
      self.storeBrief = []
      var url = '/storeOrderAmountLimitSetting/getStoreList?brand_id=' + brandId + '&type=create'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.store_list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].store_name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj
            } else if (i === 0) self.storeSelect.value = 999999
            // 目前由這判斷是否讀取菜單與否
          }
          // 用於讀取品牌，在尚未選擇品牌

          self.addStoresSetting.options = sList.map(x => {
            return {
              value: x.store_id,
              label: x.store_name
            }
          })
          self.addStoresSetting.choose = []
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | CopyScheduleProdTemp')
      var self = this
      self.storeBrief = []
      const storeID = Number(self.$route.query.store_id)
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            let objOption = {label: sList[i].name, value: sList[i].store_id}
            if (obj.value !== storeID) {
              self.addStoresSetting.options.push(objOption)
            }
            self.storeBrief.push(obj)
          }
          // self.addStoresSetting.options = sList.map(x => {
          //   console.log(self.$route.query.store_id)
          //   console.log(x.store_id)
          //   if (storeID === x.store_id) {
          //     return false
          //   } else {
          //     return {
          //       value: x.store_id,
          //       label: x.name
          //     }
          //   }
          // })
          self.addStoresSetting.choose = []
        }
      })
    },
    checkSetting () {
      let msg = ''
      if (this.addStoresSetting.choose.length === 0) {
        msg = '請選擇門市'
        this.getToast(msg)
      } else {
        this.getToast(msg)
      }
    },
    // 用於送出資料改寫
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        // set data
        const data = {
          store_id_list: []
        }
        // 新增門市
        this.addStoresSetting.choose.forEach(function (store) {
          data.store_id_list.push(store)
        })
        console.log(data)
        this.copyStoreSync(data)
      }
    },
    copyStoreSync (data) {
      var self = this
      const brandId = this.$route.query.brand_id
      // const storeId = this.$route.query.store_id
      const settingId = this.$route.params.setting_id
      var url = '/storeOrderAmountLimitSetting/' + settingId + '/storeSync'
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          if (brandId) {
            self.$router.push('/limitedItemScheduleTable?brand=' + brandId)
          } else {
            self.$router.push('/limitedItemScheduleTable')
          }
          // if (self.getRoleType === 10 && storeId !== 999999) {
          //   self.$router.push('/limitedItemScheduleTable?store=' + storeId)
          // } else if(brandId) {
          //   self.$router.push('/limitedItemScheduleTable?store=' + brandId)
          // }
          // if (self.getRoleType === 99 || self.getRoleType === 30) {
          //   self.$router.push('/limitedItemScheduleTable?brand=' + brandId)
          // } else if (self.getRoleType === 10 && storeId !== 999999) {
          //   self.$router.push('/limitedItemScheduleTable?store=' + storeId)
          // } else {
          //   self.$router.push('/limitedItemScheduleTable')
          // }
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    }
  },
  created () {
    this.getStoreBrief(this.$route.query.brand_id)
  }
}
</script>
<style lang="sass">
$default-color: #e1456d
$light-gray: rgb(238, 238, 238)
.label-text-60-p
  font-size: 60% !important
.m-t-10
  margin-top: 10px !important
.m-b-5
  margin-bottom: 5px !important
.m-r-5
  margin-right: 5px !important
.m-r-20
  margin-right: 20px !important
.m-r-15
  margin-right: 15px !important
.m-t-64
  margin-top: 64px !important
.display-time
  font-family: "Source Sans Pro", "Helvetica Neue", Helvetica, Arial, sans-serif
  padding: 6px 12px !important
.multiselect__placeholder
  padding: 0px !important
.msl-search-list-input
  border: 1px solid #ddd
.msl-searchable-list__items
  border: 1px solid #ddd !important
.msl-searchable-list__item
  border-bottom: 1px solid #ddd !important
.left_store_sec
  float: left;
  width: calc(50% - 30px);
.middle_store_sec
  float: left;
  width: 40px;
  margin: 0px 4px;
.right_store_sec
  float: left;
  width: calc(50% - 30px);
.block-checkbox
  right: 0px
  position: absolute
  top: 3px
.card-title .block-checkbox
  top: 8px
.checkbox-visible, .checkbox-enable
  margin-left: 20px
.text-dark-gray
  color: #333 !important
.text-light-gray
  color: #666 !important
.text-13
  font-size: 13px !important
.text-14-4 
  font-weight: normal
  font-size: 14.4px !important
.multiselect__single
  font-size: 14.4px !important
.msl-search-list-input
  font-size: 14.4px !important
.btn-option-show
  background: #ffffff
  border: 1px solid $default-color
  min-width: 100px
  font-size: 15px
  border-radius: 5px
  cursor: auto
input[type="checkbox"]
  margin-left: 0
  padding: 0
input[type=checkbox].css-checkbox
  position: absolute
  overflow: hidden
  clip: rect(0 0 0 0)
  height: 1px
  width: 1px
  margin: -1px
  padding: 0px
  border: 0
input[type=checkbox].css-checkbox+label.css-label
  padding-left: 22px
  height: 16px
  width: 16px
  display: inline-block
  line-height: 15px
  background-repeat: no-repeat
  background-position: 0 0
  font-size: 13px
  vertical-align: middle
  cursor: pointer
  opacity: 1
input[type=checkbox].css-checkbox+label.css-label:hover
  opacity: 0.5
input[type=checkbox].css-checkbox:checked+label.css-label
  background-position: 0 -17px
.css-label:not(.css-label-add)
  background-image: url(/static/img/checkbox.png)
  background-size: 16px
.css-label.css-label-add
  background-image: url(/static/img/checkbox-delete.png)
  background-size: 16px
input[type=checkbox].css-checkbox+label.css-label.disabled:hover
  opacity: 1
.delete-line
  text-decoration: line-through;
.box-border
  border-top: 1px solid #e1456d;;
.h3-title
  color: #e1456d;
  font-size: 24px;
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fff;
.hr-line
  position: absolute;
  width: 100%;
  display: inline-lock;
  border-top: 1px solid #e1456d;
  top: 19px;
small
  color: dimgrey
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>
<style lang="sass" scoped>
  table.table-bordered tbody th, table.table-bordered tbody td
    vertical-align: middle
</style>



// WEBPACK FOOTER //
// CopyScheduleProdTemp.vue?5410b844